module.exports = __webpack_public_path__ + "img/TV.a5157369.png";